import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { useMultiStyleConfig, Flex, NumberInput, InputGroup, InputLeftElement, NumberInputField, InputRightElement, NumberInputStepper, NumberIncrementStepper, NumberDecrementStepper, Slider as Slider$1, SliderMark, SliderTrack, SliderFilledTrack, SliderThumb } from '@chakra-ui/react';
import { i18n } from '../../../i18n/index.js';
import { CoreTooltipPlacement } from '../Tooltip/types.js';
import { CoreTooltip } from '../Tooltip/component.js';
var _excluded = ["onChange", "value", "controls", "markers", "variant", "step", "prefix", "postfix", "tooltip"];
var Slider = function Slider(_ref) {
  var _onChange = _ref.onChange,
    value = _ref.value,
    controls = _ref.controls,
    markers = _ref.markers,
    variant = _ref.variant,
    _ref$step = _ref.step,
    step = _ref$step === void 0 ? 1 : _ref$step,
    prefix = _ref.prefix,
    postfix = _ref.postfix,
    tooltip = _ref.tooltip,
    rest = _objectWithoutProperties(_ref, _excluded);
  var styles = useMultiStyleConfig('Slider', {
    variant: variant
  });
  return /*#__PURE__*/React.createElement(Flex, {
    "data-testid": "core-slider",
    __css: styles.flex
  }, controls && /*#__PURE__*/React.createElement(NumberInput, {
    min: rest.min,
    max: rest.max,
    step: step,
    value: value,
    alignSelf: "flex-end",
    mr: "2rem",
    maxW: "120px",
    onChange: function onChange(val) {
      return _onChange === null || _onChange === void 0 ? void 0 : _onChange(Number(val));
    }
  }, /*#__PURE__*/React.createElement(InputGroup, null, /*#__PURE__*/React.createElement(InputLeftElement, {
    position: "unset",
    w: "auto",
    px: 3
  }, prefix)), /*#__PURE__*/React.createElement(NumberInputField, {
    paddingInlineEnd: 0,
    w: "auto"
  }), postfix && /*#__PURE__*/React.createElement(InputGroup, null, /*#__PURE__*/React.createElement(InputRightElement, {
    position: "unset",
    w: "auto",
    px: 3
  }, postfix)), /*#__PURE__*/React.createElement(NumberInputStepper, null, /*#__PURE__*/React.createElement(NumberIncrementStepper, {
    "aria-label": i18n.t('Increase number of Range Field')
  }), /*#__PURE__*/React.createElement(NumberDecrementStepper, {
    "aria-label": i18n.t('Decrease number of Range Field')
  }))), /*#__PURE__*/React.createElement(Slider$1, _extends({
    orientation: variant,
    minH: variant === 'vertical' ? '56' : undefined,
    value: value,
    focusThumbOnChange: !controls,
    onChange: _onChange,
    step: step,
    variant: variant
  }, rest), markers === null || markers === void 0 ? void 0 : markers.map(function (marker, index) {
    return /*#__PURE__*/React.createElement(SliderMark, {
      key: index,
      value: marker,
      __css: styles.mark
    }, "".concat(prefix ? "".concat(prefix) : '').concat(marker).concat(postfix ? "".concat(postfix) : ''));
  }), /*#__PURE__*/React.createElement(SliderTrack, null, /*#__PURE__*/React.createElement(SliderFilledTrack, null)), /*#__PURE__*/React.createElement(SliderThumb, null), tooltip && /*#__PURE__*/React.createElement(CoreTooltip, {
    placement: variant === 'vertical' ? CoreTooltipPlacement.RIGHT : CoreTooltipPlacement.TOP,
    isOpen: true,
    label: "".concat(prefix ? "".concat(prefix) : '').concat(value).concat(postfix ? "".concat(postfix) : '')
  }, /*#__PURE__*/React.createElement(SliderThumb, null))));
};
Slider.displayName = "Slider";
export { Slider };